module.exports = __webpack_public_path__ + "img/land-icon.5a9d4aa2.svg";